<template>
    <div class="page page-flex bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="page-state">
            <van-tabs v-model="tabActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.title" :name="item.value" v-for="(item,$index) in tabList" :key="$index"></van-tab>
            </van-tabs>
        </div>

        <div class="flex1 posi-rel product-list">
            <div class="product-item">
                <div class="product-img">
                    <img :src="img" alt="">
                    <div class="cargo">101</div>
                    <div class="Shortage">缺货数 12</div>
                </div>
                <div class="mt-15 text-el fs-28 color-333">山楂糖250g</div>
                <div class="flex-center mt-15 fs-26">
                    <div class="color-999">补货数</div>
                    <div class="number color-fff bg-main">0</div>
                    <div class="color-main click">补满</div>
                </div>
                <div class="btn click" @click="$router.push({name:'exchangeProduct'})">换绑商品</div>
            </div>

        </div>

        <div class="fixed-bot flex">
            <div class="btn2 click">全部补满</div>
            <div class="btn click flex1" style="font-size: .28rem;" @click="">确定补货 <span class="fs-24">(补货后，请关门盘点库存)</span></div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "springSupplyCompare",
        components:{backTitleBar},
        data(){
            return{
                tabList:[
                    {title:'第1层',value:'1'},
                    {title:'第2层',value:'2'},
                    {title:'第3层',value:'3'},
                    {title:'第4层',value:'4'},
                    {title:'第5层',value:'5'},
                ],
                img:require("../../assets/images/shopHome/tag8.png")
            }
        },
        methods:{
            //切换
            tabClick(name){
                switch (name) {
                    case '1':
                        break;
                    case '2':
                        break;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .product-list{
        padding: .1rem .25rem .2rem;
        display: flex;
        flex-wrap: wrap;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        .product-item{
            width: 3.45rem;
            height: 5.35rem;
            padding: .15rem .15rem .2rem;
            background: #fff;
            border-radius: .12rem;
            margin-top: .1rem;
            &:nth-child(2n+1){
                margin-right: .1rem;
            }
            .product-img{
                width: 100%;
                height: 3.15rem;
                position: relative;
                .cargo{
                    position: absolute;
                    top: 0;
                    left: 0;
                    padding: 0 .1rem;
                    line-height: .5rem;
                    height: .5rem;
                    border-radius: 0 .25rem .25rem 0;
                    background: rgba(0,0,0,.7);
                    color: #fff;
                    font-size: .26rem;
                }
                .Shortage{
                    height: .5rem;
                    line-height: .5rem;
                    width: 100%;
                    text-align: center;
                    background:rgba(255,133,0,.9);
                    color: #fff;
                    font-size: .26rem;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                }
            }
        }
        .number{
            width: .8rem;
            height: .38rem;
            line-height: .38rem;
            text-align: center;
            border-radius: .06rem;
            margin: 0 .2rem;
        }
        .btn{
            margin-top: .2rem;
            height: .52rem;
            line-height: .5rem;
            text-align: center;
            border: .01rem solid $main-color;
            background: rgba(131,194,33,.1);
            color: $main-color;
            font-size: .26rem;
            border-radius: .06rem;
        }
    }
    .btn2{
        width: 2.1rem;
        margin-right: .2rem;
        border-radius: .24rem;
        background: #F2F2F2;
        font-size: .28rem;
        color: $main-color;
        text-align: center;
        line-height: .88rem;
    }
</style>



// WEBPACK FOOTER //
// springSupplyCompare.vue?7e0c246c